// extracted by mini-css-extract-plugin
export default {"use_case_bubbles":"use_case_bubbles___zd1t0","bg":"bg___XlA4w","container":"container___g59tF","btn_container":"btn_container___XLmuu"};